import { Link } from "react-router-dom";
import { seriesList } from "@/mocks/series";
import { newsList } from "@/mocks/news";

const characterCount = seriesList.reduce((sum, item) => sum + item.characters.length, 0);
const years = seriesList.map((item) => item.year);
const span = `${Math.min(...years)} - ${Math.max(...years)}`;

const stats = [
  { label: "收录剧集", value: seriesList.length, suffix: " 部", icon: "ri-film-line" },
  { label: "角色档案", value: characterCount, suffix: " 位", icon: "ri-user-star-line" },
  { label: "资讯文章", value: newsList.length, suffix: " 篇", icon: "ri-article-line" },
  { label: "内容跨度", value: span, suffix: "", icon: "ri-history-line" },
];

export default function SiteIntro() {
  return (
    <section className="bg-primary-900 text-primary-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-accent-400">
              <span className="h-px w-6 bg-accent-500"></span>
              About the site
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
              一个为仙侠剧迷打造的
              <br className="hidden md:block" />
              仙剑奇侠传影视内容站
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-primary-200 md:text-base">
              从 2005 年的《仙剑奇侠传》到近年的仙侠新作，我们整理了剧集资料、剧情脉络、角色档案与观剧资讯。
              无论你是想重温经典，还是想快速了解一部新剧，这里都能找到清晰的入口。
            </p>

            <div className="mt-7 grid grid-cols-2 gap-4 sm:grid-cols-4 lg:grid-cols-2 xl:grid-cols-4">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="rounded-lg border border-primary-800 bg-primary-950/40 p-4"
                >
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-800 text-accent-400">
                    <i className={`${stat.icon} text-lg`}></i>
                  </span>
                  <p className="mt-3 font-heading text-xl font-bold text-background-50">
                    {stat.value}
                    <span className="text-sm font-normal text-primary-300">{stat.suffix}</span>
                  </p>
                  <p className="mt-1 text-xs text-primary-300">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col justify-center gap-5">
            <div className="rounded-lg border border-primary-800 bg-primary-950/40 p-6">
              <h3 className="font-heading text-lg font-bold text-background-50">观影路线建议</h3>
              <ul className="mt-4 space-y-3 text-sm text-primary-200">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line mt-0.5 text-accent-400"></i>
                  <span>初识仙剑：从《仙剑奇侠传》开始，理解系列的世界观基底。</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line mt-0.5 text-accent-400"></i>
                  <span>进阶重温：接着看《仙剑奇侠传三》，感受轮回线的叙事魅力。</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line mt-0.5 text-accent-400"></i>
                  <span>扩展版图：再到相关仙侠剧，认识更多经典作品与角色。</span>
                </li>
              </ul>
              <div className="mt-6 flex flex-wrap gap-3">
                <Link
                  to="/category"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-400"
                >
                  <i className="ri-layout-grid-line"></i>
                  开始浏览剧集
                </Link>
                <Link
                  to="/about"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-700 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-800"
                >
                  <i className="ri-information-line"></i>
                  了解本站
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}